import React, { useEffect, useState } from "react";
import "./VendorData.css";

const VendorData = ({ eventData, setEventData, vendors, categoryError }) => {
  const [selectedServices, setSelectedServices] = useState({});

  useEffect(() => {
    const initialSelectedServices = {};
    eventData.vendors.forEach((vendorData) => {
      initialSelectedServices[vendorData.vendor] = vendorData.services;
    });
    setSelectedServices(initialSelectedServices);
  }, [eventData]);

  const toggleService = (vendorName, service) => {
    setSelectedServices((prevState) => {
      const vendorServices = prevState[vendorName] || [];
      const isSelected = vendorServices.includes(service);

      const updatedServices = isSelected
        ? vendorServices.filter((s) => s !== service)
        : [...vendorServices, service];

      const updatedSelectedServices = {
        ...prevState,
        [vendorName]: updatedServices,
      };

      const updatedEventVendors = Object.keys(updatedSelectedServices)
        .filter((vendor) => updatedSelectedServices[vendor].length > 0)
        .map((vendor) => ({
          vendor: vendor,
          services: updatedSelectedServices[vendor],
        }));

      setEventData((prevState) => ({
        ...prevState,
        vendors: updatedEventVendors,
      }));

      return updatedSelectedServices;
    });
  };

  useEffect(() => {
    console.log("Updated Event Data: ", eventData);
  }, [eventData]);

  return (
    <>
      {vendors?.map((vendor) => (
        <div className="form-items vendor-form-items" key={vendor.vendor}>
          <label className="form-label">{vendor.vendor}</label>
          <div className="d-flex align-items-center flex-wrap gap-2 wrap">
            {vendor.services.map((service, index) => {
              const isSelected =
                selectedServices[vendor.vendor]?.includes(service);
              return (
                <div
                  key={index}
                  className={`service-overflow `}
                  onClick={() => toggleService(vendor.vendor, service)}
                >
                  <div
                    className={`services-wrapper ${
                      isSelected ? "selected" : ""
                    }`}
                  >
                    <span>{isSelected ? "−" : "+"}</span>
                    {service}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      {categoryError.category && (
        <span className="error-text">{categoryError.category}</span>
      )}
    </>
  );
};

export default VendorData;
